module.exports = __webpack_public_path__ + "static/divisek-c103afdd2b094b61fa981fce3e1a0e04.jpg";